import { useState } from 'react';
import type { VoidFunctionComponent } from 'react';

import Button, { BUTTON_SIZE } from '../../generic/Button';
import Flex from '../../generic/Flex';
import type { MalwareReport } from '../../../../shared/model-typings/malwarereport';

import MalwareReportsTable from './MalwareReportsTable';
import ModalMalware from './ModalMalware';

const ManualMalwareComponent: VoidFunctionComponent = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMalwareReport, setSelectedMalwareReport] = useState<MalwareReport | undefined>();

  const openAddMalwareDialog = () => {
    setSelectedMalwareReport(undefined);
    setIsModalOpen(true);
  };

  const openEditMalwareDialog = (malwareReport: MalwareReport) => {
    setSelectedMalwareReport(malwareReport);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedMalwareReport(undefined);
  };

  return (
    <div className="card">
      <Flex justify="space-between">
        <h3 className="card-title padding-bottom-sm">Manual Malware</h3>
        <Button size={BUTTON_SIZE.MEDIUM} onClick={openAddMalwareDialog}>Add</Button>
      </Flex>
      <MalwareReportsTable onEditMalware={openEditMalwareDialog} />
      <ModalMalware
        show={isModalOpen}
        onHide={closeModal}
        malwareReport={selectedMalwareReport}
      />
    </div>
  );
};

export default ManualMalwareComponent;
